import tw, { styled, css } from 'twin.macro';

export const StyledStatBarBlockV2 = styled.section<{ layout?: string }>`
  ${tw`grid gap-4`}
  ${({ layout }) => (layout === 'right' ? tw`lg:grid-cols-2` : tw`lg:grid-cols-1`)}
  ${tw`p-1 pt-4 md:p-[12px] md:pt-4 lg:p-4`}
  ${tw`bg-ui-colours-ui7`}
  ${tw`text-primary-p1`}
  ${tw`rounded-md md:rounded-lg lg:rounded-[32px]`}
`;

export const StyledHeadline = styled.h2`
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-mobile-display-xl md:text-display-xl`}
`;

export const StyledBody = styled.p`
  ${tw`pt-3`}
  ${tw`font-inter font-regular`}
  ${tw`text-body-l`}
`;

export const StyledHeader = styled.div`
  ${tw`pr-4 lg:pt-4`}
`;

export const StyledStatBlocksContainer = styled.div<{ layout?: string; blockCount?: number }>`
  ${tw`grid grid-cols-1 md:grid-cols-2 gap-3 lg:gap-x-4`}
  ${tw`[&>*:last-of-type:nth-of-type(odd)]:md:col-span-2`}

  ${({ layout, blockCount }) => {
    if (layout === 'right') {
      return css`
        ${tw`lg:grid-cols-2`}
      `;
    }
    return css`
      ${tw`lg:grid-cols-6 *:lg:col-span-2`}
      ${blockCount === 5 &&
      tw`[&>*:nth-of-type(n+4)]:lg:col-span-3 [&>*:last-of-type:nth-of-type(odd)]:md:col-span-3`}
      ${(blockCount === 4 || blockCount === 2) && tw`*:lg:col-span-3`}
      ${blockCount === 1 && tw`[&>*:last-of-type:nth-of-type(odd)]:md:col-span-6`}
    `;
  }}
`;

export const StyledComponentWrapper = styled.div`
  ${tw`container`}
  ${tw`px-1 md:px-0`}
`;
